const defaultStates = {
  tags: [],
  radius: {
    on: false,
    value: "10",
    disabled: false
  },
  collapseDuplicates: {
    enabled: true
  },
  alphaProducts: new Map(),
  imageProducts: new Map([
    [
      "analysis",
      new Map([
        ["250hpa", { keys: ["UPPER_ANALYSIS//250HPA"], enabled: false }],
        [
          "500hpaThkns",
          { keys: ["UPPER_ANALYSIS//500HPA/THKNS"], enabled: false }
        ],
        [
          "500hpaVort",
          { keys: ["UPPER_ANALYSIS//500HPA/VORT"], enabled: false }
        ],
        ["700hpa", { keys: ["UPPER_ANALYSIS//700HPA"], enabled: false }],
        ["850hpa", { keys: ["UPPER_ANALYSIS//850HPA"], enabled: false }],
        ["surface", { keys: ["SURFACE_ANALYSIS"], enabled: false }]
      ])
    ],
    [
      "radar",
      new Map([
        [
          "nationalEchotop",
          { keys: ["COMPOSITE_RADAR/ECHOTOP/NAT"], enabled: false }
        ],
        [
          "nationalCappiRain",
          { keys: ["COMPOSITE_RADAR/LOW_RAIN~CAPPI/NAT"], enabled: false }
        ],
        [
          "nationalCappiSnow",
          { keys: ["COMPOSITE_RADAR/LOW_SNOW~CAPPI/NAT"], enabled: false }
        ],
        [
          "regionalEchotop",
          {
            keys: ["PAC", "WRN", "ONT", "QUE", "ERN"].map(
              geography => `COMPOSITE_RADAR/ECHOTOP/${geography}`
            ),
            enabled: false
          }
        ],
        [
          "regionalCappiRain",
          {
            keys: ["PAC", "WRN", "ONT", "QUE", "ERN"].map(
              geography => `COMPOSITE_RADAR/LOW_RAIN~CAPPI/${geography}`
            ),
            enabled: false
          }
        ],
        [
          "regionalCappiSnow",
          {
            keys: ["PAC", "WRN", "ONT", "QUE", "ERN"].map(
              geography => `COMPOSITE_RADAR/LOW_SNOW~CAPPI/${geography}`
            ),
            enabled: false
          }
        ],
        ["individualEchotop", { keys: ["RADAR/ECHOTOP"], enabled: false }],
        ["individualCappiRain", { keys: ["RADAR/CAPPI_RAIN"], enabled: false }],
        ["individualCappiSnow", { keys: ["RADAR/CAPPI_SNOW"], enabled: false }]
      ])
    ],
    [
      "satellite",
      new Map([
        ["ir", { enabled: false }],
        ["vis", { enabled: false }],
        ["yknnwt3u", { keys: ["SATELLITE/3u/*/*"], enabled: false }]
      ])
    ],
    [
      "graphicalForecast",
      new Map([
        ["gfaCldwx", { keys: ["GFA/CLDWX"], enabled: false }],
        ["gfaTurbc", { keys: ["GFA/TURBC"], enabled: false }],
        ["lgf", { keys: ["LGF"], enabled: false }]
      ])
    ],
    [
      "significantWeather",
      new Map([
        ["highLevel", { keys: ["SIG_WX//HIGH_LEVEL/*"], enabled: false }],
        ["midLevel", { keys: ["SIG_WX//MID_LEVEL/*"], enabled: false }],
        [
          "surfaceDepiction",
          { keys: ["SIG_WX/DEPICTION/SURFACE/*"], enabled: false }
        ]
      ])
    ],
    [
      "turbulence",
      new Map([["all", { keys: ["TURBULENCE"], enabled: false }]])
    ],
    [
      "wind",
      new Map([
        ["fl030", { keys: ["LOW_LEVEL_WIND/FL030"], enabled: false }],
        ["fl060", { keys: ["LOW_LEVEL_WIND/FL060"], enabled: false }],
        ["fl090", { keys: ["LOW_LEVEL_WIND/FL090"], enabled: false }],
        ["fl120", { keys: ["LOW_LEVEL_WIND/FL120"], enabled: false }],
        ["fl180", { keys: ["LOW_LEVEL_WIND/FL180"], enabled: false }],
        ["fl240", { keys: ["HIGH_LEVEL_WIND/FL_240"], enabled: false }],
        ["fl340", { keys: ["HIGH_LEVEL_WIND/FL_340"], enabled: false }],
        ["fl390", { keys: ["HIGH_LEVEL_WIND/FL390"], enabled: false }],
        ["fl450", { keys: ["HIGH_LEVEL_WIND/FL450"], enabled: false }]
      ])
    ]
  ]),
  showMeta: true,
  showTimestamp: true,
  sortOrder: {
    weather: "type",
    bulletin: "time"
  }
};
defaultStates.alphaProducts.set("sigmet", {
  enabled: true
});
defaultStates.alphaProducts.set("airmet", {
  enabled: true
});
defaultStates.alphaProducts.set("notam", {
  enabled: true,
  value: "default",
  title: "notam.language-label"
});
defaultStates.alphaProducts.set("metar", {
  title: "historical_hours",
  enabled: true,
  historicalHours: 1,
  value: ""
});
defaultStates.alphaProducts.set("taf", {
  enabled: true
});
defaultStates.alphaProducts.set("pirep", {
  enabled: true
});
defaultStates.alphaProducts.set("upperwind", {
  enabled: true
});
defaultStates.alphaProducts.set("space_weather", {
  enabled: true
})
defaultStates.alphaProducts.set("vfr_route", {
  enabled: false
});

export default defaultStates;

export const OBST_LIGHT_FILTER = {
  translationKey: "alphaFilters.FILTER_OBST_LIGHTS",
  pattern: "Q\\) [A-Z]{4}\\/QOL(.|[\n\r])*OBST LGT U\\/S"
};

export const CRANE_FILTER = {
  translationKey: "alphaFilters.FILTER_CRANES",
  pattern: "Q\\) [A-Z]{4}\\/QOB(.|[\n\r])*CRANE"
};

export const predefinedFilters = {
  notam: [OBST_LIGHT_FILTER, CRANE_FILTER]
};

export const productChoices = {
  metar: [
    { value: "", label: "0H" },
    { value: 1, label: "1H" },
    { value: 2, label: "2H" },
    { value: 3, label: "3H" },
    { value: 4, label: "4H" },
    { value: 5, label: "5H" },
    { value: 6, label: "6H" }
  ],
  notam: [
    { value: "default", label: "notam.default" },
    { value: "english", label: "notam.english" },
    { value: "french", label: "notam.french" }
  ]
};
